import { Injectable } from '@angular/core';

import { ApiService }       from '../../../api/api.service';
import { HaynesProService } from '../../haynes-pro.service';
import { VehicleModel }     from '../../../vehicles/models/vehicle';

@Injectable({
  providedIn: 'root'
})
export class VesaService {

  private _faultCodesPromise ?: Promise<any>;

  constructor (
    private apiService : ApiService
  ) {}

  getDiagnosticConnectorImage ( vehicleId : number ) : Promise<any> {
    return this.apiService.get('/haynes_pro/electronics/diagnostic_connector_image', [ vehicleId ]);
  }

  getFilteredFaultCodesWithDiagnosticSteps ( vehicleId : number, faultCode : string ) : Promise<any> {
    return this.apiService.get('/haynes_pro/electronics/filter_fault_codes_with_diagnostic_steps', [ vehicleId, faultCode ]);
  }

  getVesaCompleteComponent ( vehicleId : number, componentId : string, systemTypeId : string ) : Promise<any> {
    return this.apiService.get(
      `/haynes_pro/electronics/vesa_complete_component/${vehicleId}?component_id=${componentId}&system_type_id=${systemTypeId}`,
      undefined,
      undefined,
      { skipEncoding: true }
    );
  }

  getVesaComponentImageUrl ( componentImageId : string ) : string {
    if (!componentImageId) {
      return '';
    }

    return `${HaynesProService.WORKSHOP_DATA_BASE_URL}/getimage?id=${componentImageId}`;
  }

  getVesaComponentsList ( vehicleId : number, systemTypeIds : Array<string> ) : Promise<any> {
    const queryString = systemTypeIds
      .map(id => `system_type_ids[]=${id}`)
      .join('&');

    return this.apiService.get(`/haynes_pro/electronics/vesa_components_list/${vehicleId}?${queryString}`, undefined, undefined, { skipEncoding: true });
  }

  getVesaFaultCodes ( vehicleId : number ) : Promise<any> {
    return this._faultCodesPromise
      || this.apiService.get('/haynes_pro/electronics/fault_codes', [ vehicleId ]);
  }

  getVesaNetworks ( vehicleId : number, selections : Array<{ system_type_id: string, group_id: string }> ) : Promise<any> {
    const queryString = selections
      .map(s => `system_type_ids[]=${s.system_type_id}&system_type_group_ids[]=${s.group_id}`)
      .join('&');

    return this.apiService.get(`/haynes_pro/electronics/vesa_networks/${vehicleId}?${queryString}`, undefined, undefined, { skipEncoding: true });
  }

  getVesaRepairTimesByGenarts ( vehicleId : number, genartIds : Array<string> ) : Promise<any> {
    const queryString = `genart_ids=${( genartIds || [] ).join(',')}`;

    return this.apiService.get(
      `/haynes_pro/electronics/repair_times_by_genarts/${vehicleId}?${queryString}`,
      undefined,
      undefined,
      { skipEncoding: true }
    );
  }

  getVesaSystems ( vehicle : VehicleModel ) : Promise<Array<any>> {
    return this.apiService.get('/haynes_pro/electronics/vesa_systems', [ vehicle.id ]);
  }

  getWiringComponents ( vehicleId : number, mimeDataName : string ) : Promise<any> {
    return this.apiService.get(
      `/haynes_pro/electronics/wiring_components/${vehicleId}?mime_data_name=${encodeURIComponent(mimeDataName || '')}`,
      undefined,
      undefined,
      { skipEncoding: true }
    );
  }

  getWiringDiagramSchemes ( vehicleId : number, diagramSystemId : string ) : Promise<any> {
    return this.apiService.get(
      `/haynes_pro/electronics/wiring_diagram_schemes/${vehicleId}/${diagramSystemId}`,
      undefined,
      undefined,
      { skipEncoding: true }
    );
  }

  preloadVesaFaultCodes ( vehicleId : any ) : void {
    if (!this._faultCodesPromise) {
      this._faultCodesPromise = this.apiService.get('/haynes_pro/electronics/fault_codes', [ vehicleId ]);
    }
  }
}
